module.exports = __webpack_public_path__ + "img/copy.979ca887.svg";